import React from 'react';
import NotificationItem from './NotificationItem';
import CustomScrollbars from 'util/CustomScrollbars';
import { requestGql } from '../../constants/Request'
import IntlMessages from 'util/IntlMessages';
import {DropdownMenu, DropdownToggle} from 'reactstrap';
import CardHeader from 'components/dashboard/Common/CardHeader/index';
import IconButton from '@material-ui/core/IconButton';

class AppNotification extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 10,
      notifications: [
        // {
        //   image: 'https://via.placeholder.com/120x120',
        //   title: "Stella Johnson has recently posted an album",
        //   time: "4:10 PM",
        //   icon: "zmdi-thumb-up text-blue",
        // }, {
        //   image: 'https://via.placeholder.com/150x150',
        //   title: "Alex Brown has shared Martin Guptil's post",
        //   time: "5:18 PM",
        //   icon: "zmdi-comment-text text-grey",
        // }, {
        //   image: 'https://via.placeholder.com/208x208',
        //   title: "Domnic Brown has sent you a group invitation for Global Health",
        //   time: "5:36 PM",
        //   icon: "zmdi-card-giftcard text-info",
        // }, {
        //   image: 'https://via.placeholder.com/150x150',
        //   title: "John Smith has birthday today",
        //   time: "5:54 PM",
        //   icon: "zmdi-cake text-warning",
        // }, {
        //   image: 'https://via.placeholder.com/150x150',
        //   title: "Chris has updated his profile picture",
        //   time: "5:25 PM",
        //   icon: "zmdi-account-box-o text-grey",
        // }
      ]
    }
  }

  UNSAFE_componentWillMount() {
    let { offset, limit } = this.state;
    this.getListNotifycation(offset, limit);
  }

  getListNotifycation(offset, limit) {
    const query = `
        query getListAdminNotifycation(
              $offset: Int
              $limit: Int
            ){
              getListAdminNotifycation(
                offset : $offset
                limit : $limit
                ){
                  listNotification{
                      title,
                      time,
                      data,
                      notify_type,
                      is_read,
                      description,
                      id
                  },
                  error{
                      code,
                      msg
                  }
                }
              }
            `;
        const variables = {
          offset,
          limit
        };
        requestGql(query, variables)
            .then(result => {
                if (result.getListAdminNotifycation) {
                    if (!result.getListAdminNotifycation.error) {
                        let { listNotification } = result.getListAdminNotifycation;
                        this.setState({
                          notifications: listNotification
                        });
                    } else {
                        console.log("====================getListAdminNotifycation=========",result.getListAdminNotifycation.error.message);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
  }

  clickNotify = (notify_id, link, is_read) => {
    let { notifications } = this.state ;
    let { props } = this.props;
    if(!is_read) {
    const query = `
        query readAdminNotify(
              $notify_id: Int
            ){
              readAdminNotify(
                notify_id : $notify_id
                ){
                  success,
                  error{
                      code,
                      msg
                  }
                }
              }
            `;
        const variables = {
          notify_id
        };
        requestGql(query, variables)
            .then(result => {
                if (result.readAdminNotify) {
                    if (!result.readAdminNotify.error) {
                      notifications = notifications.map(it => {
                        if(it.id === notify_id) {
                          it.is_read = 1
                        }
                        return it
                      })
                      this.setState({
                        notifications
                      })
                      props.history.push(link)
                    } else {
                        alert(result.readAdminNotify.error.message);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
    }else{
      props.history.push(link)
    }
    this.props.onAppNotificationSelect();
  }

  handleUpdateData = () => {
    let { offset, limit } = this.state;
    this.getListNotifycation(offset, limit);
  };

  render() {
    let { notifications } = this.state ;
    let checkRead = notifications.findIndex(it => !it.is_read)
    return (
      <React.Fragment>
        <DropdownToggle
        className="d-inline-block"
        tag="span"
        data-toggle="dropdown">
        <IconButton className="icon-btn">
          <i className={`zmdi zmdi-notifications-none ${checkRead === -1 ? "" : "icon-alert"} animated infinite wobble`}/>
        </IconButton>
      </DropdownToggle>

          <DropdownMenu right>
            <CardHeader handleUpdateData={this.handleUpdateData.bind(this)} styleName="align-items-center" heading={<IntlMessages id="appNotification.title"/>}/>
              <CustomScrollbars className="messages-list scrollbar" style={{height: 280}}>
                <ul className="list-unstyled">
                  {notifications.map((notification, index) => <NotificationItem key={index} notification={notification} clickNotify={this.clickNotify} />)
                  }
                </ul>
              </CustomScrollbars>
          </DropdownMenu>
        </React.Fragment>
        )
      }
}

export default AppNotification;

